import React from "react";

import { capitalizeString } from "./../../../../../utilities/helpers";

import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

export default function Voucher({ voucher }) {
  const getStatus = (claimed) => {
    if (claimed) return "redeemed";
    return "active";
  };

  const getColor = (claimed) => {
    if (claimed) return "redeemed";
    return "active";
  };

  return (
    <Card as="li" body className="card-list">
      <div className="card-body-heading--flex flex-grow-1 m-0">
        <Card.Title as="h5" className="card-title-sm">
          {voucher?.code}
        </Card.Title>
        <Badge bg="none" className={`badge--${getColor(voucher?.claimed)}`}>
          {capitalizeString(getStatus(voucher?.claimed))}
        </Badge>
      </div>
    </Card>
  );
}
